/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
// material Ui Stuffs
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Grid, Fab, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import KeyboardArrowRightRoundedIcon from '@material-ui/icons/KeyboardArrowRightRounded';
import { Link as RouterLink } from 'react-router-dom';
import AddClient from './AddClient';
import { Client } from '../redux/types';
import { RootState } from '../redux/root';
import getDateAsString from '../helpers/dateHelper';


const useStyles = makeStyles((theme) => ({
  '@global': {
    i: {
      fontSize: '2em',
    },
  },
  table: {
    margin: 'auto',
    maxWidth: '50em',
  },
  button: {
    margin: theme.spacing(1),
  },
  grid: {
    margin: 'auto',
    display: 'flex',
    alignContent: 'center',
    maxWidth: '50em',
  },
  fab: {
    margin: theme.spacing(2),
  },
  root: {
    margin: theme.spacing(2),
    marginTop: '3em',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
  },
}));


function displayClients(clients: Client[]) {
  const result: JSX.Element[] = [];
  clients.map((client: Client) => {
    result.push(
      <TableRow key={client.id}>
        <TableCell>{client.name}</TableCell>
        <TableCell>{getDateAsString(client.lastUpdated)}</TableCell>
        <TableCell>
          <IconButton component={RouterLink} to={`/Client/${client.id}`} size="small" color="secondary">
            <KeyboardArrowRightRoundedIcon />
          </IconButton>
        </TableCell>
      </TableRow>,
    );
    return undefined;
  });
  return result;
}

function displayFilter(filter: string, setFilter: Function) {
  return (
    <TextField
      variant="outlined"
      fullWidth
      margin="normal"
      id="filter"
      label="Filter"
      name="filter"
      autoComplete="filter"
      autoFocus
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
    />
  );
}


const Clients : React.FC = () => {
  const [filter, setFilter] = useState('');
  const [addClientOpen, setAddClientOpen] = useState(false);
  const name: string = useSelector((state: RootState) => state.user.name);
  let clients: Client[] = useSelector((state: RootState) => state.clients.clients);
  const classes = useStyles();
  if (filter) {
    // eslint-disable-next-line max-len
    clients = clients.filter((client) => client.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }
  clients.sort((a, b) => b.lastUpdated.getTime() - a.lastUpdated.getTime());
  return (
    <div className={classes.root}>
      <Typography component="h1" variant="h3" className={classes.grid}>
        {name}
        &apos;s Clients
      </Typography>
      <Grid container className={classes.grid}>
        <Grid item xs={10}>
          {displayFilter(filter, setFilter)}
        </Grid>
        <Grid item xs={2}>
          <Fab className={classes.fab} color="primary" aria-label="add" onClick={() => setAddClientOpen(true)}>
            <AddIcon />
          </Fab>
        </Grid>
      </Grid>
      <Grid container className={classes.grid}>
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Last Updated</TableCell>
                  <TableCell>&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayClients(clients)}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <AddClient isOpen={addClientOpen} setOpen={setAddClientOpen} />
    </div>

  );
};


export default Clients;
